// extracted by mini-css-extract-plugin
export default {"app":"App_app__RBBgB","background":"App_background__+wkrZ","content_wrapper":"App_content_wrapper__JoPiz"};